import { ClientWebCoreEntrypoint } from '@client/cores/web';

export function ClientWebCore() {
  return (
    <ClientWebCoreEntrypoint
      config={{
        one: 'jahlsdf',
      }}
    />
  );
}
